require("./dist/main.ts");


//////////////////
// WEBPACK FOOTER
// core-js-error (bower component)
// module id = 11
// module chunks = 0